import { BarChart } from './BarChart';
import { ChartBox } from './ChartBox';
import { ChartLegend } from './ChartLegend';
import { PieChart } from './PieChart';

export type ValueFormatter = (value: string | number) => string | number;

export interface ChartItem {
    name: string;
    fill: string;
    [key: string]: string | number;
}

export const Chart = {
    Box: ChartBox,
    Pie: PieChart,
    Bar: BarChart,
    Legend: ChartLegend,
};
